
import { BaseModel } from '@shared/models/worksheet/BaseModel';
import { PlatoFieldSection } from './plato-field-section.model';

export class PlatoField extends BaseModel {
    farmId: string;
    name: string;
    fieldSections: PlatoFieldSection[] = [];

    constructor(init?: Partial<PlatoField>) {
        super();
        this.name = this.isEn ? 'Field 1' : 'Champ 1';
        this.fieldSections[0] = new PlatoFieldSection(init);
        Object.assign(this, init);
    }
}
